import { HOME_FIELDS } from "./home";
import { EUGENIE_FIELDS } from "./eugenie";
import { CONFERENCES_FIELDS } from "./conferences";
import { CONTACT_FIELDS } from "./contact";
import { PROJETS_FIELDS } from "./projets";
import { MEDIAS_FIELDS } from "./medias";
import { CONVERSATIONS_FIELDS } from "./conversations";
import { RESSOURCES_FIELDS } from "./ressources";
import { CONFIDENTIALITE_FIELDS } from "./confidentialite";
import { CLINIQUE_FIELDS } from "./clinique";
import { SITE_FIELDS } from "./site";

// Registre central des contenus éditables du site.
// Chaque page y déclare ses champs ; l'admin génère le formulaire à partir de ce registre
// et le site affiche la valeur personnalisée (admin) ou la valeur par défaut (def).

export const CONTENT_MANIFEST = [
  { page: "home", label: "Accueil", fields: HOME_FIELDS },
  { page: "eugenie", label: "Eugénie", fields: EUGENIE_FIELDS },
  { page: "clinique", label: "Clinique", fields: CLINIQUE_FIELDS },
  { page: "conversations", label: "Conversations", fields: CONVERSATIONS_FIELDS },
  { page: "medias", label: "Médias", fields: MEDIAS_FIELDS },
  { page: "conferences", label: "Conférences", fields: CONFERENCES_FIELDS },
  { page: "projets", label: "Projets", fields: PROJETS_FIELDS },
  { page: "contact", label: "Contact", fields: CONTACT_FIELDS },
  { page: "ressources", label: "Ressources d'aide", fields: RESSOURCES_FIELDS },
  { page: "confidentialite", label: "Confidentialité", fields: CONFIDENTIALITE_FIELDS },
  { page: "site", label: "Menu & pied de page", fields: SITE_FIELDS },
];

export const CONTENT_DEFAULTS = Object.fromEntries(
  CONTENT_MANIFEST.flatMap((p) => p.fields.map((f) => [f.key, f.def]))
);
